var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"mainBody"},[_c('router-view')],1),_c('PopupModal'),_c('AlertModal'),_c('ConfirmModal'),_c('ModalRejectAlarm'),_c('ModalNotifyMatching'),_c('MFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }